module.exports = __webpack_public_path__ + "img/hand_6_on.282a1d64.svg";